export default __webpack_public_path__ + "static/media/videos.d7e630dd.svg";